import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Check } from "lucide-react";

const ConfirmationPopup = ({ onCancel, deleteTaskMail, taskToDeleteId, boardName = "Board", customMessage }) => {
    return ReactDOM.createPortal(
        <div className="relative z-[9999]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                style={{ zIndex: 9998 }}
                aria-hidden="true"
                onClick={onCancel}
            />
            {/* Modal panel */}
            <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
                <div className="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all w-full max-w-sm">
                    {/* Close button */}
                    <button
                        type="button"
                        className="absolute top-3 right-3 p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none"
                        onClick={onCancel}
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    {/* Icon */}
                    <div className="flex flex-col items-center px-6 pt-8 pb-2 text-center">
                      <div
  className="flex items-center justify-center w-20 h-20 rounded-full mb-4"
  style={{ backgroundColor: "#ddffe9" }}
>
 <Check size={64} color="#1a7d3e" strokeWidth={3.5} />
</div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-1" id="modal-title">
                            Confirm Action
                        </h3>
                        <p className="text-sm text-gray-500 leading-relaxed">
                            {customMessage ? customMessage : `Are you sure you want to delete this ${boardName}?`}
                        </p>
                        {!customMessage && (
                            <p className="text-sm text-gray-400 mt-1">You will no longer be able to view it.</p>
                        )}
                    </div>

                    {/* Divider */}
                    <div className="mx-6 mt-2 border-t border-gray-100" />

                    {/* Actions */}
                    <div className="flex gap-3 px-6 py-3">
                        <button
                            type="button"
                            className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors focus:outline-none"
                            onClick={onCancel}
                        >
                            No, Cancel
                        </button>
                        <button
                            type="button"
                            className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-white transition-colors focus:outline-none"
                            style={{ backgroundColor: '#1a7d3e' }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1a6b2e'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a7d3e'}
                            onClick={() => {
                                deleteTaskMail(taskToDeleteId);
                            }}
                        >
                            Yes, I'm Sure
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

ConfirmationPopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
    deleteTaskMail: PropTypes.func.isRequired,
    taskToDeleteId: PropTypes.string,
    boardName: PropTypes.string,
    customMessage: PropTypes.string,
};

export default ConfirmationPopup;
